module.exports = __webpack_public_path__ + "static/media/morgan-go-drive.f0043119.png";